var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('edu-tree-select',{ref:"eduTree",attrs:{"width":_vm.width,"check":false,"nodes":_vm.treeNodes}})}
var staticRenderFns = []

export { render, staticRenderFns }